import { EVENTS_LIST } from '../constants/events';

const roundToPercent = (n) => {
	if (!Number.isFinite(n)) {
		return '—';
	}
	return (n * 100).toFixed(2).replace('.', ',') + ' %';
};

export const getQuizReportRawEventsTableRows = (data = {}) => {
	const rows = EVENTS_LIST.map((eventKey, i) => {
		const val = Number(data[eventKey] ?? 0);
		const prev = i > 0 ? Number(data[EVENTS_LIST[i - 1]] ?? 0) : null;
		const first = Number(data[EVENTS_LIST[0]] ?? 0);

		const partialCR = i !== 0 && prev > 0 ? roundToPercent(val / prev) : '—';
		const totalCR = i !== 0 && first > 0 ? roundToPercent(val / first) : '—';

		return (
			<tr key={eventKey}>
				<td>{eventKey}</td>
				<td>{val}</td>
				<td>{partialCR}</td>
				<td>{totalCR}</td>
			</tr>
		);
	});

	return rows;
};

export const getQuizNamedEventsTableRows = (data = {}) => {
	const tableData = [
		['LP views', data.AD_QUIZ_LP, '---', '---'],
		[
			'Start quiz',
			data.AD_QUIZ_Q1,
			roundToPercent(data.AD_QUIZ_Q1 / data.AD_QUIZ_LP),
			roundToPercent(data.AD_QUIZ_Q1 / data.AD_QUIZ_LP),
		],
		[
			'Finish quiz',
			data.AD_QUIZ_LEAD,
			roundToPercent(data.AD_QUIZ_LEAD / data.AD_QUIZ_Q1),
			roundToPercent(data.AD_QUIZ_LEAD / data.AD_QUIZ_LP),
		],
		[
			'Submitted Leads',
			data.AD_QUIZ_LEAD_SUBMITTED,
			roundToPercent(data.AD_QUIZ_LEAD_SUBMITTED / data.AD_QUIZ_LEAD),
			roundToPercent(data.AD_QUIZ_LEAD_SUBMITTED / data.AD_QUIZ_LP),
		],
		[
			'SP views ',
			data.AD_QUIZ_SP,
			roundToPercent(data.AD_QUIZ_SP / data.AD_QUIZ_LEAD_SUBMITTED),
			roundToPercent(data.AD_QUIZ_SP / data.AD_QUIZ_LP),
		],
		[
			'Checkout',
			data.AD_QUIZ_CHECKOUT,
			roundToPercent(data.AD_QUIZ_CHECKOUT / data.AD_QUIZ_SP),
			roundToPercent(data.AD_QUIZ_CHECKOUT / data.AD_QUIZ_LP),
		],
		[
			'Init Checkout',
			data.AD_QUIZ_INIT_CHECKOUT,
			roundToPercent(data.AD_QUIZ_INIT_CHECKOUT / data.AD_QUIZ_CHECKOUT),
			roundToPercent(data.AD_QUIZ_INIT_CHECKOUT / data.AD_QUIZ_LP),
		],
		[
			'Purchase (ALL)',
			data.purchase,
			roundToPercent(data.purchase / data.AD_QUIZ_INIT_CHECKOUT),
			roundToPercent(data.purchase / data.AD_QUIZ_LP),
		],
		['Promotion view', data.AD_QUIZ_SP_PROMO, '----', '----'],
		[
			'Checkout Promo',
			data.AD_QUIZ_CHECKOUT_PROMO,
			roundToPercent(data.AD_QUIZ_CHECKOUT_PROMO / data.AD_QUIZ_SP_PROMO),
			roundToPercent(data.AD_QUIZ_CHECKOUT_PROMO / data.AD_QUIZ_SP_PROMO),
		],
		[
			'Init Checkout Promo',
			data.AD_QUIZ_INIT_CHECKOUT_PROMO,
			roundToPercent(
				data.AD_QUIZ_INIT_CHECKOUT_PROMO / data.AD_QUIZ_CHECKOUT_PROMO,
			),
			roundToPercent(data.AD_QUIZ_INIT_CHECKOUT_PROMO / data.AD_QUIZ_SP_PROMO),
		],
		[
			'Purchase Promo',
			data.promoPurchase,
			roundToPercent(data.promoPurchase / data.AD_QUIZ_INIT_CHECKOUT_PROMO),
			roundToPercent(data.promoPurchase / data.AD_QUIZ_SP_PROMO),
		],
	];

	const rows = tableData.map((data, i) => (
		<tr key={i}>
			{data.map((d, j) => (
				<td key={j}>{d}</td>
			))}
		</tr>
	));

	return rows;
};
